import { render, staticRenderFns } from "./DynamicTableHeightWrapper.vue?vue&type=template&id=770da494"
import script from "./DynamicTableHeightWrapper.vue?vue&type=script&lang=js"
export * from "./DynamicTableHeightWrapper.vue?vue&type=script&lang=js"
import style0 from "./DynamicTableHeightWrapper.vue?vue&type=style&index=0&id=770da494&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports